// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"194":"caf273aad66f69d5","454":"87db747536671be8","647":"3ccccd53530e598f"}[chunkId] + ".js";
};